"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JobDetailsController = function () {
  function JobDetailsController($stateParams, JobsService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, JobDetailsController);
    this.jobsService = JobsService;
    this.jobId = $stateParams.jobId;
    this.$scope = $scope;
    this.getJobPaymentDetails(this.jobId);
  }

  (0, _createClass3.default)(JobDetailsController, [{
    key: "getJobPaymentDetails",
    value: function getJobPaymentDetails(jobId) {
      var _this = this;

      this.isLoading = true;

      this.jobsService.getJobPaymentDetails(jobId, function (response) {
        _this.invoices = response.data;
        _this.isLoading = false;
        _this.$scope.$apply();
      }, function (error) {
        _this.isLoading = false;
        _this.error = "Payment details not found";
        _this.$scope.$apply();
      });
    }
  }, {
    key: "payHelper",
    value: function payHelper(invoiceId) {
      var _this2 = this;

      console.log('payHelper called with invoiceId:', invoiceId);
      var invoice = this.invoices.find(function (inv) {
        return inv.id === invoiceId;
      });
      if (!invoice) {
        console.log('Invoice not found');
        return;
      }

      console.log('Processing payment for invoice:', invoice);
      invoice.isProcessing = true;
      this.$scope.$apply();

      this.jobsService.payHelper(invoiceId, function (response) {
        console.log('Payment success:', response);
        invoice.isProcessing = false;
        alert('Payment processed successfully');
        _this2.getJobPaymentDetails(_this2.jobId);
      }, function (error) {
        console.log('Payment error:', error);
        invoice.isProcessing = false;
        alert(error.response && error.response.data && error.response.data.Message || 'Payment failed');
        _this2.$scope.$apply();
      });
    }
  }, {
    key: "formatCurrency",
    value: function formatCurrency(amount) {
      return amount ? "$" + amount.toFixed(2) : '-';
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return date ? new Date(date).toLocaleDateString('en-AU') : '-';
    }
  }]);
  return JobDetailsController;
}();

exports.default = JobDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-details/job-details.controller.js
 **/